import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'
import EndUserSuggestFormScreen from './EndUserSuggestFormScreen'

const EndUserSuggestFormRoutes = () => {
  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><EndUserSuggestFormScreen /></PrivateRoute7>} />
        
    </Routes>
  )
}

export default EndUserSuggestFormRoutes